import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import Keycloak from 'keycloak-js';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const keycloak: Keycloak = inject(Keycloak);
    // Check the authentication status
    if (!keycloak?.authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL =
            state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
    }
    // Allow the access
    return of(true);
};
